import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEvent = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Livello_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 18 18",
	style: { enableBackground: "new 0 0 18 18" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill-rule:evenodd;clip-rule:evenodd;}\n"
	}), /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M12.3,16.8c-2.5,0-4.3-1.7-4.3-4v-1.1c0-2.3,1.8-3.9,4.3-3.9s4.3,1.6,4.3,3.9v1.2 C16.6,15.2,14.8,16.8,12.3,16.8z M12.3,18c3.3,0,5.7-2.2,5.7-5.7c0-3.3-2.4-5.7-5.7-5.7C9,6.6,6.6,9,6.6,12.3C6.6,15.8,9,18,12.3,18 z M11.4,9.8h1.1v2.6l2,1.9L13.8,15l-2.4-2.2V9.8z M5.4,0v1.9h6.8V0h1.4v1.9H16c1,0,1.6,0.6,1.6,1.6V6h-1.4V3.2h-2.6V5h-1.4V3.2H5.4 V5H4V3.2H1.4v11.1H5v1.3H1.6C0.6,15.6,0,15,0,14V3.5c0-1,0.6-1.6,1.6-1.6H4V0H5.4z"
	})]
});
export default SvgEvent;
